import React, { useCallback } from 'react';
import styled, { keyframes } from 'styled-components';
import { useAppState } from '../../data';
import CookiesDialog from '../cookies-dialog/CookiesDialog';

const GrowIn = keyframes`
  0% {
    transform: translate3d(0, 100%, 0);
  }

  100% {
    transform: translate3d(0, 0%, 0);
  }
`;

const RootContainer = styled.div<{backgroundColor: string}>`
  background-color: ${props => props.backgroundColor};
  position: fixed;
  z-index: 2147483641;
  bottom: 0;
  right: 0;
  left: 0;
  max-height: 90%;
  overflow: hidden auto;

  animation-name: ${GrowIn};
  animation-duration: 800ms;
  animation-timing-function: ease-in-out;
`;

const Title = styled.h3<{textColor: string}>`
  color: ${props => props.textColor};
  font-size: 1.2em;
  line-height: 1.3;
  font-weight: 600;
  margin-top: .8em;
  margin-bottom: .5rem;
`;

const Text = styled.p<{textColor: string}>`
  color: ${props => props.textColor};
  font-size: .88em;
  line-height: 1.4;
  text-align: justify;
  margin-top: 0;
  margin-bottom: 1rem;
  font-weight: 300;
`;

const AceptButton = styled.button<{textColor: string, backgroundColor: string}>`
  background-color: ${props => props.backgroundColor};
  color: ${props => props.textColor};
  min-width: 125px;
  height: auto;
  white-space: normal;
  word-break: break-word;
  word-wrap: break-word;
  padding: 12px 10px;
  line-height: 1.2;
  display: inline-block;
  text-align: center;
  font-size: 0.9em;
  font-weight: 400;
  letter-spacing: 0.01em;
  text-decoration: none;
  border-radius: 2px;
  border: 1px solid ${props => props.backgroundColor};
  cursor: pointer;
  box-sizing: border-box;
  margin-bottom: 1em;
  width: 100%;
  outline: none;

  @media (min-width: 440px) {
    width: auto;
  }
`;

const ConfigButton = styled.button<{textColor: string, backgroundColor: string}>`
  background-color: ${props => props.textColor};
  color: ${props => props.backgroundColor};
  min-width: 125px;
  height: auto;
  white-space: normal;
  word-break: break-word;
  word-wrap: break-word;
  padding: 12px 10px;
  line-height: 1.2;
  display: inline-block;
  text-align: center;
  font-size: 0.9em;
  font-weight: 400;
  letter-spacing: 0.01em;
  text-decoration: none;
  border-radius: 2px;
  border: 1px solid ${props => props.backgroundColor};
  cursor: pointer;
  box-sizing: border-box;
  margin-bottom: 1em;
  width: 100%;
  margin-right: 0;
  outline: none;

  @media (min-width: 440px) {
    width: auto;
    margin-right: 1em;
  }
`;


const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (min-width: 440px) {
    flex-direction: row;
  }
`;

function ConsentBox() {
  const { setShowApp, appConfig, openDialog, setOpenDialog, showBottomPanel } = useAppState();

  const handleAccept = useCallback(() => {
    setShowApp(false);
    localStorage.setItem('sydle_one_lgpd_closed', new Date().toISOString());
  }, [setShowApp]);

  return (
    <>
      {showBottomPanel && (
        <RootContainer backgroundColor={appConfig.UIConfig?.backgroundColor} as="ldiv">
          <ldiv className="container">
            <ldiv className="row">
              <ldiv className="col-12 col-lg-7">
                <ldiv className="row">
                  <ldiv className="col">
                    <Title textColor={appConfig.UIConfig?.textFontColor} as="ldiv">{appConfig.UIConfig?.overlayTitle}</Title>
                  </ldiv>
                </ldiv>
                <ldiv className="row">
                  <ldiv className="col">
                    <Text textColor={appConfig.UIConfig?.textFontColor} as="ldiv" className="text-justify" dangerouslySetInnerHTML={{__html: appConfig.UIConfig?.overlayText}}/>
                  </ldiv>
                </ldiv>
              </ldiv>
              <ButtonContainer as="ldiv" className="col-12 col-lg-5 mb-lg-0">
                <ConfigButton
                  onClick={() => setOpenDialog(true)}
                  backgroundColor={appConfig.UIConfig?.buttonBackgroundColor}
                  textColor={appConfig.UIConfig?.buttonFontColor}
                  className="mb-lg-0"
                >{appConfig.UIConfig?.settingsButtonText}</ConfigButton>
                <AceptButton
                  onClick={handleAccept}
                  backgroundColor={appConfig.UIConfig?.buttonBackgroundColor}
                  textColor={appConfig.UIConfig?.buttonFontColor}
                  className="mb-lg-0"
                >{appConfig.UIConfig?.acceptButtonText}</AceptButton>
              </ButtonContainer>
            </ldiv>
          </ldiv>
        </RootContainer>
      )}
      <CookiesDialog open={openDialog} />
    </>
  );
}

export default ConsentBox;